import type { AppModule } from '@/core/types';

import { usersRoute, userEditRoute } from './routes';

export const UsersModule: AppModule = {
  routes: { usersRoute, userEditRoute },
};
